import {createSelector, split, keyBy, lowerCase, sortBy} from 'helpers';
import {user} from 'store/session';

export const tags = createSelector(
  [ state => state.tags, user ],
  ( tags, user ) => {
    const ordered = sortBy(tags, tag => lowerCase(tag.name));
    const byName = keyBy(ordered, tag => lowerCase(tag.name));
    return {
      byId: tags,
      byName,
      getById: id => tags[id],
      getByIds: ids => split(ids, /\D+/).map(id => tags[id]).filter(Boolean),
      getByName: name => byName[lowerCase(name).trim()],
      ordered: ordered.filter(tag => !tag.userId || tag.userId == user.id), //only display current user's tags
      sort,
    }
  }
);

function sort(data = []) {
  const withoutTag = [];
  const groups = {};
  for (const object of data) {
    const tags = this.getByIds(object.tagIds);
    if (tags.length) {
      tags.forEach(tag => {
        groups[tag.name] = groups[tag.name] || [];
        groups[tag.name].push(object);
      });
    } else {
      withoutTag.push(object);
    }
  }
  return { ...groups, withoutTag }
}
